function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })

    let prods = window.product
    function getCur() {
      let opt1 = $('#Size div.active').attr('data-val')
      let opt2 = $('#opt2 div.active').attr('data-val')
      let opt3 = $('#opt3 div.active').attr('data-val')
      return prods.filter(item => 
        item.option1 == opt1
      &&item.option2 == opt2
      &&item.option3 == opt3
      )[0]
    }
    function changePrice() {
      let num = $('#calcNumber').val()
      let price = ((getCur().price * num) / 100).toFixed(2)
      let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
      price = (price + '').replace('.', ',')
      compare = (compare + '').replace('.', ',')
      $('#new').html(price)
      $('#old').html(compare)
    }
    $('.sp-btn-style').click(function () {
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })

    //加减
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        changePrice()
      }
      var number = Number($('#calcNumber').val())
      $('#new').html((number * Number(83.9)).toFixed(2))
      $('#old').html((number * Number(119.99)).toFixed(2))
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      var number = Number($('#calcNumber').val())
      $('#new').html((number * Number(83.9)).toFixed(2))
      $('#old').html((number * Number(119.99)).toFixed(2))
      changePrice()
    })
    new Swiper('.mySwiper', {
      loop: true,
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
    })
    var swiper = new Swiper('.mySwiper2', {
      loop: true,
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    // style选项
    let typeOptions = $('#Size .option')
    let opt2Options = $('#opt2 .option')
    let opt3Options = $('#opt3 .option')
    var imgArr = [
      'https://boniss.com/cdn/shop/files/spp_20241213175443_baf1aa6a89c9c44060b58d6c8d041e69_c15fd0f4-aef4-4888-a90f-5a52486e82d3.jpg?v=1752647202',
      'https://boniss.com/cdn/shop/files/IMG_1057_72818946-2280-44fb-9db5-b3ff09ec8e3d.jpg?v=1752647202&width=990',
      'https://boniss.com/cdn/shop/files/spp_20250115163148_b223ff444ec3d0e17467aa84075263d4_89be9fc6-ea74-48a6-9034-cd3cd7883124.jpg?v=1752647203',
      'https://boniss.com/cdn/shop/files/O1CN01tZtlx22AGfFAEk3U2__3296268176-0-cib_c3606715-cad1-4a69-be8a-9a28b1102af4.jpg?v=1752647203&width=990',
      'https://boniss.com/cdn/shop/files/1738826813800_a70d6556-1fac-441b-82ad-b7c8eccb72ac.jpg?v=1752647202',
      'https://boniss.com/cdn/shop/files/hui2_ffee31b5-0776-4084-9164-fd4dc6bf5bc3.jpg?v=1752647202&width=990',
      'https://boniss.com/cdn/shop/files/spp_20241213175445_b43870167d83a8ff9094a9f173cbc81d_832cafee-fed9-4661-9f54-acf24ef66402.jpg?v=1752647203',
      'https://boniss.com/cdn/shop/files/spp_20241213175443_baf1aa6a89c9c44060b58d6c8d041e69_c15fd0f4-aef4-4888-a90f-5a52486e82d3.jpg?v=1752647202',
      'https://boniss.com/cdn/shop/files/spp_20250115163149_5d44cb575497d147795791fff662084b_4f2e6ae3-03f2-493e-a85d-cd59ef0cf61d.jpg?v=1752647203',
      'https://boniss.com/cdn/shop/files/IMG_1088_c0b473f7-0b64-4d27-9339-e623f9ee5437.jpg?v=1752647203&width=990',
      'https://boniss.com/cdn/shop/files/IMG_1071_9b8e8d4f-0120-465d-a79e-a6fb0f940274.jpg?v=1752647203&width=990',
      'https://boniss.com/cdn/shop/files/IMG_1068_01cd2e8f-1d7f-4456-ac62-4b20241ac135.jpg?v=1752647203&width=990',
      'https://boniss.com/cdn/shop/files/IMG_1080_516da581-5032-4e5d-bd12-65555fc1c825.jpg?v=1752647203&width=990',
      'https://boniss.com/cdn/shop/files/IMG_1066_2cd56035-ee00-43c5-90d1-c0b477d12d38.jpg?v=1752647203&width=990',
      'https://boniss.com/cdn/shop/files/IMG_1061_f80826b3-2551-46a5-aeaf-ca8fc964018c.jpg?v=1752647203&width=990',
      'https://boniss.com/cdn/shop/files/IMG_1074_6a7b2232-3d56-4332-bdf1-c9c6e14ba97c.jpg?v=1752647203&width=990',
      'https://boniss.com/cdn/shop/files/Snipaste_2025-03-17_17-46-20_eea4229e-9a53-4635-884f-363e791d7be7.png?v=1752647203',
      // 'https://boniss.com/cdn/shop/files/IMG_1080_516da581-5032-4e5d-bd12-65555fc1c825.jpg?v=1752647203&width=990',
    ]
    // 切换选项
    $('.option').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      $('.top-product>img').attr('src', getCur().featured_image.src);
      let bind = $('#opt3 div.active').index()
      if(bind){
        $("#num-tips").show()
      }else{
        $("#num-tips").hide()
      }
      changePrice()
    })
    $('#sp-sizes').click(function () {
      $('.mask').css('display', 'flex')
      $('.mask .size-pop').css('display', 'flex')
      $('.mask .img-pop').css('display', 'none')
    })
    addCart()
    function addCart() {
      // 加入购物车
      $('#addCart').click(function () {
        // do something here
        var number =
          Number($('.sp-cart #cardNum').html()) + Number($('#calcNumber').val())
        // $('.sp-cart #cardNum').html(number)
        var data = {
          id: getCur().id,
          quantity: $('#calcNumber').val(),
        }
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          success: function () {
            $.getJSON(
              window.Shopify.routes.root + 'cart.js',
              function (result) {
                $('#cardNum').html(result.item_count)
              }
            )
          },
          dataType: 'json',
        })
        var img = $('.top-product>img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 30,
            left: finish[0].offsetLeft + finish.width() / 2 - 30,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          targetElement.offsetTop -
          $('.time-part').height() -
          $('.sp-header-top').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
$("#num-tips").hide()
